import { render, staticRenderFns } from "./TaRightsGroup.vue?vue&type=template&id=0fa8d8a0"
import script from "./TaRightsGroup.vue?vue&type=script&lang=js"
export * from "./TaRightsGroup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports